(function () {
  function setExpandedState(trigger, isOpen) {
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-fv-toggle]');
    if (!trigger) return;

    var targetId = trigger.getAttribute('data-fv-toggle');
    if (!targetId) return;

    var panel = document.getElementById(targetId);
    if (!panel) return;

    var isOpen = panel.hasAttribute('open');
    if (isOpen) {
      panel.removeAttribute('open');
      setExpandedState(trigger, false);
      return;
    }

    panel.setAttribute('open', 'open');
    setExpandedState(trigger, true);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var openPanels = document.querySelectorAll('[open][id]');
    openPanels.forEach(function (panel) {
      panel.removeAttribute('open');
      var trigger = document.querySelector('[data-fv-toggle="' + panel.id + '"]');
      if (trigger) setExpandedState(trigger, false);
    });
  });
})();
